<template>
  <div id="app">
    <main class="pwa-shell">
      <div class="card">
        <div class="badge">PWA</div>
        <h1>Vue PWA</h1>
        <p>此应用已配置为渐进式 Web 应用，可离线访问。</p>
        <button v-if="installPrompt" class="install-button" type="button" @click="installApp">
          安装应用
        </button>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      installPrompt: null
    }
  },
  mounted () {
    window.addEventListener('beforeinstallprompt', this.captureInstallPrompt)
  },
  beforeDestroy () {
    window.removeEventListener('beforeinstallprompt', this.captureInstallPrompt)
  },
  methods: {
    captureInstallPrompt (event) {
      event.preventDefault()
      this.installPrompt = event
    },
    async installApp () {
      if (!this.installPrompt) {
        return
      }

      this.installPrompt.prompt()
      await this.installPrompt.userChoice
      this.installPrompt = null
    }
  }
}
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  min-height: 100%;
  background: linear-gradient(135deg, #f2fbf7 0%, #dff7eb 100%);
  font-family: Avenir, Helvetica, Arial, sans-serif;
}

#app {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2c3e50;
}

.pwa-shell {
  width: min(90vw, 480px);
}

.card {
  background: rgba(255, 255, 255, 0.85);
  border-radius: 18px;
  box-shadow: 0 18px 45px rgba(66, 185, 131, 0.16);
  padding: 32px 28px;
  text-align: center;
}

.badge {
  display: inline-block;
  padding: 6px 12px;
  border-radius: 999px;
  background: #42b983;
  color: #fff;
  font-size: 0.75rem;
  letter-spacing: 0.08em;
  font-weight: 700;
  text-transform: uppercase;
}

h1 {
  margin: 18px 0 10px;
  font-size: clamp(2rem, 4vw, 3rem);
}

p {
  margin: 0;
  line-height: 1.6;
  font-size: 1rem;
}

.install-button {
  margin-top: 24px;
  border: 0;
  border-radius: 999px;
  padding: 12px 22px;
  background: #42b983;
  color: #fff;
  cursor: pointer;
  font: inherit;
  font-weight: 700;
}

.install-button:hover {
  background: #369f70;
}
</style>
